import { Node } from '@tiptap/core'

const UploadPlaceholder = Node.create({
  name: 'uploadPlaceholder',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: false,
  isolating: true,

  addAttributes() {
    return {
      uploadId: { default: null },
      fileName: { default: '' }
    }
  },

  parseHTML() {
    return [{ tag: 'span[data-upload-placeholder]' }]
  },

  renderHTML({ HTMLAttributes }) {
    const fileName = HTMLAttributes.fileName || 'file'
    return [
      'span',
      {
        ...HTMLAttributes,
        'data-upload-placeholder': '',
        contenteditable: 'false',
        class: 'upload-placeholder'
      },
      `[Uploading "${fileName}"...]`
    ]
  },

  renderText({ node }) {
    return `[Uploading "${node.attrs.fileName}"...]`
  }
})

export default UploadPlaceholder
